<template>
    <div class="thank-you-container">
        <div class=" content">
            <v-row>
                <v-col cols="12">
                    <h1 v-if="page.title">{{ page.title}}</h1>
                    <p>{{ page.description}}</p>
                </v-col>
                <v-col cols="12" class="btn-back__row">
                    <v-btn color="primary" block class="btn-back" height="45" :to="'/'">Back to Home
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import SiteService from "../services/site.service";
import { flattenObj } from "@/utils/utils";

export default {
    metaInfo() {
        return {
            meta: [
                { name: 'description', content: 'EDUrent\'s shared housing program provides the traditional college experience. Students share a space with classmates and make new friends on day one at move-in. Instead of a cramped, overpriced dorm room, you have the space and luxury of a full-size apartment home with a well-equipped kitchen. Our units are furnished with beds, dressers, and a couch and include utilities like electricity, and water, all at one low monthly cost. Each student in the program has an individual lease agreement and therefore is not responsible for roommates\' rent payments should a bed become vacant. Students in this program tend to carpool to school, study together, and share in this new life experience. Welcome to EDUrent!' },
            ]
        }
    },
    data () {
        return {            
            page: []
        }
    },

    methods: {
        async fetchThankYouPage() {
            const response = await SiteService.getThankYouPage();
            this.page = flattenObj(response);
        },
    },

    beforeMount() {
        this.fetchThankYouPage();
    }
}
</script>


<style scoped>
div.thank-you-container {
    display: flex;
    min-height: 100%;
    background-image: url("../../src/assets/media/Hero.jpg");
    background-position: center center;
    background-size: cover!important;
    min-width: 100vw;
    background-repeat: no-repeat;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url("../../src/assets/media/Hero.jpg");
}
div.thank-you-container .row .col {
    z-index: 2;
}
div.thank-you-container h1,
div.thank-you-container p {
    color: #fff;
    text-align: center;
}
div.thank-you-container h1 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 64px;
    line-height: 1.125;
    margin-bottom: 1.2rem;
}
div.thank-you-container p {
    margin-bottom: 5rem;
}
div.thank-you-container .btn-back__row {
    max-width: 147px;
    margin: 3% auto;
}
div.thank-you-container .btn-back__row .v-btn {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    /* identical to box height */
    letter-spacing: normal;
    text-transform: capitalize;
    text-align: center;

    /* White */

    color: #FFFFFF;
}
    @media screen and (max-width: 1600px) {
        div.thank-you-container h1 {
           
            font-size: clamp(30px, 5vw, 50px);
        }
        div.thank-you-container{
            padding: 10% 20px;
        }
    }
    @media screen and (max-width: 767px) {
        div.thank-you-container h1,
        div.thank-you-container p {
            max-width: 430px;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>
